import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import './UserNavigator.scss';
const UserNavbar = () => {
  const [{ user }] = useGlobalState();
  const { userAddress } = useParams();
  return (
    <Flexbox className='usernavbar_wrapper' fw justifyContent='flex-start' gap='0.25rem'>
      <NavLink to={`/profile/${userAddress || user?.address}/projects`} className='usernavbar_wrapper__link' activeClassName='usernavbar_wrapper__active'>
        <ThemedText.P>Project Stats</ThemedText.P>
      </NavLink>
      <NavLink to={`/profile/${userAddress || user?.address}/chains`} className='usernavbar_wrapper__link' activeClassName='active'>
        <ThemedText.P>Chain Stats</ThemedText.P>
      </NavLink>
      <NavLink to={`/profile/${userAddress || user?.address}/takes`} className='usernavbar_wrapper__link' activeClassName='active'>
        <ThemedText.P>Takes</ThemedText.P>
      </NavLink>
    </Flexbox>
  );
};

export default UserNavbar;
